import React from 'react'
import backgroundImage from "../config/baehwa_1935.jpg";
import { Image, Box } from "grommet";
import { useRecoilState } from "recoil";
import {
  widthR,
  heightR,
  portraitModeR,
} from "../recoils/windowSize";

import { getScreenDimension } from "../config/design";

const BackgroundImage = () => {

  const [ScreenWidth, setScreenWidth] = useRecoilState(widthR)
  const [ScreenHeight, setScreenHeight] = useRecoilState(heightR)

  const detectSize = () => {
    let dimension = getScreenDimension()
    setScreenWidth(dimension[0])
    setScreenHeight(dimension[1])
  };

  React.useEffect(() => {
    let dimension = getScreenDimension();
    setScreenWidth(dimension[0]);
    setScreenHeight(dimension[1]);

    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, []);

  const [portraitMode, setPortraitMode] = useRecoilState(portraitModeR)

  React.useEffect(() => {
    if (ScreenWidth < ScreenHeight) {
      setPortraitMode(true)
    } else {
      setPortraitMode(false)
    }
  }, [ScreenWidth])

  return(
    <Box
      align="center"
      justify="center"
      style={{
        position: "absolute",
        zIndex: "0",
        top: "0",
        left: "0"

      }}
      width="full"
      height="full"
      background="black"
    >
      <Image
        fit="cover"
        alignSelf="stretch"
        fill={portraitMode ? "vertical" : "horizontal"}
        src={backgroundImage} />
    </Box>
  )
}

export default BackgroundImage;